module.exports = {
	"version": "1.0",
	"pagination": {
		"ListDomains": {
			"limit_key": "MaxItems",
			"input_token": "Marker",
			"output_token": "NextPageMarker",
			"result_key": "Domains"
		},
		"ListOperations": {
			"limit_key": "MaxItems",
			"input_token": "Marker",
			"output_token": "NextPageMarker",
			"result_key": "Operations"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/route53domains-2014-05-15.paginators.json
// module id = 752
// module chunks = 2